import * as React from 'react';
import './OrderDetailsHeader.css';

interface Props {
    month: string;
}

class OrderDetailsHeader extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <div className="order-details-header">
                <div />
                <div>
                    <span>Estim.</span>
                </div>
                <div>
                    <span>Ordered</span>
                </div>
                <div>
                    <span>Liability</span>
                </div>
                <div>
                    <span>{this.props.month}</span>
                </div>
                <div>
                    <span>Stock</span>
                </div>
                <div>
                    <span>Stock order</span>
                </div>
            </div>
        );
    }
}

export default OrderDetailsHeader;



// WEBPACK FOOTER //
// ./src/view/order/OrderDetailsHeader.tsx